import { render, staticRenderFns } from "./bando25Fase6.vue?vue&type=template&id=257fe20e&scoped=true"
import script from "./bando25Fase6.vue?vue&type=script&lang=js"
export * from "./bando25Fase6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257fe20e",
  null
  
)

export default component.exports